import { render, staticRenderFns } from "./quizQuestions.vue?vue&type=template&id=4cf91a1e"
import script from "./quizQuestions.vue?vue&type=script&lang=js"
export * from "./quizQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports